<template>
    <div class="container">
        <back-to-last-trajectory />
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-docs"></i>
                            <span>{{$t('document_templates.title')}}</span>
                        </h2>
                        <div @click.prevent="addNew" class="panel_header__action">
                            <i class="panel_header__action__icon icons icon-plus"></i>
                            <a class="button--link">{{$t('document_templates.add_new')}}</a>
                        </div>
                    </div>
                    <div class="panel__body">
                        <document-templates-table/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import DocumentTemplatesTable from '@/components/tables/document-templates/DocumentTemplatesTable';
    import BackToLastTrajectory from '@/components/general/BackToLastTrajectory';

    @Component({
        components: {
            DocumentTemplatesTable,
            BackToLastTrajectory,
        }
    })
    export default class SurveyTemplates extends Vue {
        name = 'survey-templates';

        addNew() {
            this.$router.push({
                name: 'document-template',
                params: {
                    id: 'new',
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/DocumentTemplates.vue